module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="card h-100">\n  <div class="card-body">\n  	<a href="#bills/category/'+
((__t=( name ))==null?'':_.escape(__t))+
'" oncontextmenu="return false">\n  	  <div class="card-title">'+
((__t=( name.replace(/_/g, ' ') ))==null?'':_.escape(__t))+
'</div>\n  	  <div class="card-more">\n  	    Watching '+
((__t=( count ))==null?'':_.escape(__t))+
' bill';
 if(count > 1) { 
__p+='s';
 } 
__p+='\n  	  </div>\n  	</a>\n  </div>\n</div>\n';
}
return __p;
};
